import React, { Component } from 'react';
import RadioButtonCarteraColumn from './RadioButtonCarteraColumn.jsx';

class RadioButtonCartera extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let portfolioNodes;
        let descripcion;
        let data;
        let checked;
        if (this.props.data != undefined && this.props.data != "") {
            let portfolios = JSON.parse(JSON.stringify(this.props.data.GET_CARTERAS));
            let portfolioId = this.props.data.Cartera.id;
            data = this.props.data;
            let me = this;
            portfolioNodes = portfolios.map(function (row) {
                checked = row.Id == portfolioId ? true : false;
                return (
                    <RadioButtonCarteraColumn
                        Id={row.Id}
                        Descripcion={row.Descripcion}
                        Codigo={row.Codigo}
                        checked={checked}
                        changeRadio={me.props.changeRadio} />
                );
            })
        }

        return (
            <div className="row top-separator-xs left-separator-xs">
                <div className="row">
                    <div className="col-xs-12">
                        <label className="label-primary">Cartera</label>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        {portfolioNodes}
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        {data.ERROR_EMPRESA["seleccionoCartera"] == false ? <label className="error">Debe seleccionar al menos una cartera.</label> : null}
                    </div>
                </div>
            </div>
        );
    }
};

export default RadioButtonCartera;